<template>
  <div :class="`g-menu-item ${ativo ? 'g-menu-item-ativo':''}`" :id="idItem">
    <div 
      @click="toggleAccordion()" 
      :aria-expanded="ativo"
      :aria-controls="`collapse${idItem}`"
      class="g-menu-item-titulo"
    >
      <div class="g-menu-item-indicador"></div>
      <div class="g-menu-item-titulo-texto">{{titulo}}</div>
      <i v-if="expansivel" class="pi pi-angle-down g-menu-item-icone"></i>
    </div>
    
    <div v-show="ativo" :id="`collapse${idItem}`" class="g-menu-item-conteudo">
      <g-menu-item 
        v-for="subItem in subItens" 
        :key="subItem.id" 
        :titulo="subItem.titulo" 
        :subItens="subItem.subItens" 
        :idItem="subItem.id"
        v-on:acao="$emit('acao')"
        ehSubItem
      ></g-menu-item>
    </div>
  </div>
</template>


<script>
import gMenuItem from './g-menu-item.js' 
export default gMenuItem
</script>

<style scoped>

.g-menu-item{
  margin: v-bind('margem') 0 v-bind('margem') 0;
  font-size: v-bind('fontSize');

}

.g-menu-item-titulo{
  display: grid;
  grid-template-columns: 5% 85% 10%;
  grid-template-rows: 1fr;
  grid-auto-columns: 1fr;
  gap: 0px 0px;
  grid-auto-flow: row;
  grid-template-areas:
    "indicador titulo-texto icone";
}

.g-menu-item-indicador {
  width: v-bind('larguraIndicador');
  height: v-bind('alturaIndicador');
  background-color: v-bind('corIndicador');
  grid-area: indicador;
}

.g-menu-item-titulo-texto {
  color:v-bind('corTitulo');
  font-weight: v-bind('weightTitulo');
  grid-area: titulo-texto;
}

.g-menu-item-icone {
  align-self: center;
  grid-area: icone;
}

.g-menu-item-conteudo{
  margin-left: 10px;
}

</style>
